import React from "react";
import styled from "styled-components";
import TopNavbar from "../Nav/TopNavbar";
import Footer from "./Footer";

/* Page Wrapper */

const TermsSection = styled.section`
  padding: 120px 20px 80px;
  background: #ffffff;
`;

/* Content Wrapper */

const Wrapper = styled.div`
  max-width: 1000px;
  margin: auto;
`;

/* Title */

const Title = styled.h1`
  font-size: 36px;
  margin-bottom: 20px;
`;

/* Section Title */

const SubTitle = styled.h2`
  font-size: 22px;
  margin-top: 35px;
  margin-bottom: 10px;
`;

/* Paragraph */

const Text = styled.p`
  line-height: 1.7;
  margin-bottom: 12px;
  color: #555;
`;

/* List */

const List = styled.ul`
  margin-left: 20px;
`;

const ListItem = styled.li`
  margin-bottom: 8px;
`;

/* Responsive */

const ResponsiveWrapper = styled.div`
  @media (max-width: 768px) {

    ${Title} {
      font-size: 28px;
    }

    ${SubTitle} {
      font-size: 18px;
    }

    ${TermsSection} {
      padding: 100px 20px 60px;
    }
  }
`;

const TermsConditions = () => {
  return (

    <>
            <TopNavbar/>

     <TermsSection>
      <Wrapper>

        <Title>Terms & Conditions</Title>

<Text>
Please read these Terms and Conditions carefully before using the EBK
Thangamaligai website. By accessing or using this website, you agree to
comply with and be bound by these Terms of Use and our Privacy Policy.
If you do not agree with these terms, please do not use this website.
</Text>

<SubTitle>1. Terms of Use</SubTitle>

<Text>
These Terms of Use govern your access to and use of the EBK Thangamaligai
website. These terms apply to both visitors who browse the website
("Users") and registered users who make purchases ("Members").
</Text>

<Text>
EBK Thangamaligai reserves the right to modify, update, or discontinue
any portion of the website or services without prior notice.
Users are responsible for reviewing these terms periodically.
</Text>

<SubTitle>2. Description of Services</SubTitle>

<Text>
This website provides information about jewellery collections, pricing,
offers and services offered by EBK Thangamaligai including gold,
silver, diamond and other jewellery products.
</Text>

<Text>
Some services may only be available to registered Members. Product
images are for representation purposes and may vary slightly due to
screen settings or photography.
</Text>

<SubTitle>3. User Registration</SubTitle>

<Text>
Users may register on the website before completing any transaction.
Registration may require personal information such as name, email
address, phone number and address for verification purposes.
</Text>

<Text>
Registration is a one-time process. Users who already have an account
may log in using their existing credentials.
</Text>

<SubTitle>4. Orders and Purchases</SubTitle>

<Text>
Orders placed through the website will be considered complete only
after successful payment confirmation.
</Text>

<Text>
EBK Thangamaligai may contact customers to verify orders before
processing them. If payment is rejected by the bank or payment
provider, the company reserves the right to cancel the order.
</Text>

<SubTitle>5. Website Usage Restrictions</SubTitle>

<List>
<ListItem>You must be at least 18 years old to use this website.</ListItem>
<ListItem>All information provided during registration must be accurate.</ListItem>
<ListItem>This website may only be used for personal, non-commercial purposes.</ListItem>
<ListItem>You may not modify, copy, distribute or reproduce website content.</ListItem>
<ListItem>You may not upload harmful software or viruses.</ListItem>
<ListItem>You may not misuse the website or attempt to disrupt its operations.</ListItem>
</List>

<SubTitle>6. Intellectual Property</SubTitle>

<Text>
All content on this website including text, images, graphics,
logos and product descriptions are the property of EBK Thangamaligai
and are protected under the Indian Copyright Act, 1957.
</Text>

<Text>
Unauthorized copying, reproduction, or distribution of any content
from this website is strictly prohibited.
</Text>

<SubTitle>7. Third Party Links</SubTitle>

<Text>
This website may contain links to third-party websites. EBK
Thangamaligai does not control and is not responsible for the
content or policies of those websites.
</Text>

<SubTitle>8. Disclaimer of Warranties</SubTitle>

<Text>
All information on this website is provided on an "as is" and
"as available" basis. EBK Thangamaligai does not guarantee that
the website will always be uninterrupted or error-free.
</Text>

<Text>
While we strive to display products accurately, colour,
texture and size may appear slightly different depending on
your device display settings.
</Text>

<SubTitle>9. Limitation of Liability</SubTitle>

<Text>
EBK Thangamaligai shall not be liable for any direct or indirect
damages resulting from the use or inability to use the website,
including but not limited to data loss, service interruptions,
or unauthorized access to user information.
</Text>

<SubTitle>10. Force Majeure</SubTitle>

<Text>
EBK Thangamaligai shall not be held responsible for delays or
failures caused by events beyond reasonable control including
natural disasters, power failures, technical issues, strikes,
government regulations, or other unforeseen circumstances.
</Text>

<SubTitle>11. Governing Law</SubTitle>

<Text>
These Terms and Conditions shall be governed by the laws of India.
Any disputes arising from the use of this website shall be subject
to the jurisdiction of the courts in Coimbatore, Tamil Nadu.
</Text>

<SubTitle>12. Breach of Terms</SubTitle>

<Text>
If a user violates these terms, EBK Thangamaligai reserves the
right to take appropriate legal action and recover damages
caused due to such violation.
</Text>

<SubTitle>Acceptance of Terms</SubTitle>

<Text>
By using this website, you confirm that you have read,
understood and agreed to these Terms and Conditions.
</Text>

      </Wrapper>
    </TermsSection>
          <Footer/>

    </>
   
  );
};

export default TermsConditions;